import { GET_ALL_USERS } from "../../constant/ActionType";

export default function AllDataClientsReduc(
  state = {
    getAllUsers: [],
  },
  action
) {
  switch (action.type) {
    case GET_ALL_USERS:
      return {
        ...state,
        getAllUsers: action?.data?.data,
      };

    default:
  }

  return state;
}
